(() => {
  'use strict';
  const node = document.getElementById('el-camping-config');
  if (!node || window.ELCampingOffer) return;
  let config;
  try { config = JSON.parse(node.textContent); } catch { return; }
  const start = Date.parse(config.startsAt);
  const end = Date.parse(config.endsAt);
  const active = () => Boolean(config.available && Date.now() >= start && Date.now() < end);
  const applies = (handle, variantId) => active() && handle === config.handle && (!variantId || String(variantId) === config.variantId);
  const total = (cents, count = 1) => (cents - Math.floor(cents * config.percent / 100)) * count;
  window.ELCampingOffer = { applies, total };
  let countdownTimer;
  const countdown = () => {
    const enabled = active();
    const remaining = Math.max(0, Math.ceil((end - Date.now()) / 1000));
    const parts = { days: Math.floor(remaining / 86400), hours: Math.floor(remaining / 3600) % 24, minutes: Math.floor(remaining / 60) % 60, seconds: remaining % 60 };
    document.querySelectorAll('[data-camping-countdown]').forEach(element => {
      element.hidden = !enabled;
      for (const [key, value] of Object.entries(parts)) {
        const digit = element.querySelector(`[data-countdown-${key}]`);
        if (digit) digit.textContent = String(value).padStart(2, '0');
      }
    });
    if (!enabled) clearInterval(countdownTimer);
  };
  const update = () => {
    const enabled = active();
    const sliders = new Set();
    document.querySelectorAll('[data-el-campaign]').forEach(element => {
      if (!enabled && element.matches('.el-announcement__item')) {
        const slider = element.closest('el-announcement-slider');
        if (slider) sliders.add(slider);
        element.remove();
      } else element.hidden = !enabled;
    });
    document.querySelectorAll('[data-camping-original]').forEach(element => { element.hidden = enabled; });
    document.querySelectorAll('[data-camping-copy]').forEach(element => { element.hidden = !enabled; });
    sliders.forEach(slider => slider.connectedCallback?.());
    document.dispatchEvent(new CustomEvent('easylonger:camping-change'));
  };
  const formatDate = () => {
    let label;
    try { label = new Intl.DateTimeFormat(document.documentElement.lang || 'en-US', { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit', timeZone: 'America/Los_Angeles', timeZoneName: 'short' }).format(end); } catch { return; }
    document.querySelectorAll('[data-camping-end]').forEach(element => { element.textContent = label; });
  };
  let timer;
  const schedule = () => {
    clearTimeout(timer);
    update();
    const next = Date.now() < start ? start : end;
    if (Date.now() < next) timer = setTimeout(schedule, Math.min(next - Date.now() + 20, 2147483647));
  };
  const init = () => {
    formatDate(); schedule(); clearInterval(countdownTimer); countdown();
    if (active() && !document.hidden) countdownTimer = setInterval(countdown, 1000);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  window.addEventListener('pageshow', init);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) init(); else clearInterval(countdownTimer); });
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-camping-copy]');
    if (!button || !active() || button.disabled) return;
    const controls = button.closest('.el-camping-controls');
    const status = controls?.querySelector('[data-camping-copy-status]');
    const fallback = controls?.querySelector('[data-camping-code-fallback]');
    button.disabled = true;
    try {
      await navigator.clipboard.writeText(config.code);
      if (status) status.textContent = button.dataset.copySuccess;
      if (fallback) fallback.hidden = true;
    } catch {
      if (status) status.textContent = button.dataset.copyFailed;
      if (fallback) { fallback.hidden = false; fallback.focus(); fallback.select(); }
    } finally { button.disabled = false; }
  });
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-el-campaign-link]');
    if (!link || !active()) return;
    window.ELStoreAnalytics?.track?.('select_promotion', { promotion_name: 'Camping season — ES720 PRO Camo', promotion_id: 'camping_camo', product_model: 'ES720 PRO Camo', variant_id: config.variantId, creative_slot: link.dataset.placement || 'storefront' });
  });
})();
